module.exports = __webpack_public_path__ + "img/let-there-be-ads-logo.a45b15c0.svg";